module.exports = __webpack_public_path__ + "img/clickcash.d8039f58.png";